<template>
  <v-card>

    <modal name="emails" height="auto">
      <v-card v-if="selectedOffer !== null && selectedCustomer!==null">
        <v-card-text>
          <v-card-title>
            <span>Αποστολή Μυνημάτος</span>
            <v-spacer></v-spacer>
            <v-menu
              style="z-index:1000"
              :close-on-content-click="false"
              bottom left>
              <v-btn slot="activator" icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-card>
                <add-email :customer="selectedCustomer" @addedEmail="onAddEmail"> </add-email>
              </v-card>

            </v-menu>
          </v-card-title>
          <ul>
            <li>Πελάτης: {{selectedCustomer.Name}}</li>
            <li>Προσφορα: {{selectedOffer.Title}}</li>
          </ul>

          <emails v-if="selectedCustomer" :offer="selectedOffer" :customer="selectedCustomer" :emails="selectedCustomersEmails"></emails>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="closeModal()"> Κλεισιμο </v-btn>
        </v-card-actions>
      </v-card>
    </modal>

    <v-toolbar dense color="grey" dark class="elevation-0">
      <v-toolbar-title card>
        <v-icon> mdi-key</v-icon>
        Ποιός έχει πρόσβαση σε τι
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="resetRelations()" color="white" outline round> Όλες</v-btn>
      <v-btn @click="addRelation = true" round color="light-green ">Προσθήκη</v-btn>
    </v-toolbar>

    <v-data-iterator
      :items="b2b.offerCustomers"
      row
      wrap
      class="boxes-front scroll-y"
      :rows-per-page-items="[-1]"
      content-tag="v-layout"
    >
      <v-flex
        lg12
        slot="item"
        slot-scope="props"

      >
        <v-list light dense>
          <v-list-tile>

            <v-list-tile-content>
              <v-list-tile-title>
                {{b2b.customerDictionary[props.item.CustomerID].Name}}
                <v-icon> mdi-ray-start-arrow</v-icon>
                ID:{{props.item.OfferID}}
                {{b2b.offerDictionary[props.item.OfferID].Title}}
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action v-if=" expired(b2b.offerDictionary[props.item.OfferID])">
              <v-chip small disabled>
                Έληξε
              </v-chip>
            </v-list-tile-action>
            <v-list-tile-action v-if="props.item.IsActive === '0'  ">
              <v-chip small disabled color="warning">
                Ανενεργή
              </v-chip>
            </v-list-tile-action>
            <v-list-tile-action class="pl-0">
              <v-menu
                :close-on-content-click="false"
                :nudge-width="200"
                offset-x
              >
                <v-btn
                  class="pa-0"
                  fab
                  flat
                  color="secondary"
                  small dark
                  slot="activator"
                  dark
                >
                  <v-icon> mdi-chevron-down</v-icon>
                </v-btn>
                <v-card>
                  <v-list>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{b2b.customerDictionary[props.item.CustomerID].Name}}
                          <v-icon> mdi-ray-start-arrow</v-icon>
                          {{b2b.offerDictionary[props.item.OfferID].Title}}
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                  <v-divider></v-divider>
                  <v-list>
                    <v-list-tile ripple
                                 @click="toggleRelation(props.item)">
                      <v-list-tile-content>
                        {{ props.item.IsActive !== '0'
                        ?'Απενεργοποιήση':'Ενεργοποίηση'}}
                      </v-list-tile-content>
                      <v-list-tile-action>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile
                      ripple @click="previewRelation(props.item.token,true)">
                      <v-list-tile-content>
                        Αντιγραφή Συνδέσμου
                      </v-list-tile-content>
                      <v-list-tile-action>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile
                      ripple @click="openEmail(props.item.CustomerID, props.item.OfferID)">
                      <v-list-tile-content>
                        Αποστολή Μυνήματος
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon> mdi-email-outline</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile color="blue" ripple @click="previewRelation(props.item.token)">
                      <v-list-tile-content>
                        Προεπισκόπιση
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon right color="blue"> mdi-eye-outline</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile ripple
                                 color="error"
                                 @click="deleteRelation(props.item.CustomerID, props.item.OfferID )">
                      <v-list-tile-content>
                        Διαγραφή
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon color="error"> mdi-key-remove</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                  <v-divider></v-divider>
                </v-card>
              </v-menu>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-data-iterator>
    <v-dialog v-model="addRelation" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Προσθήκη Πρόσβασης</span>
          <v-spacer></v-spacer>

        </v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="newCustomer"
            :items="b2b.customers"
            label="Επιλογή Πελάτη"
            item-value="ID"
            item-text="Name"
          ></v-autocomplete>
          <v-autocomplete
            v-model="newOffer"
            :items="b2b.offers"
            label="Επιλογή Προσφοράς"
            item-value="ID"
            :item-text="(item)=>item.Title +' ID:'+item.ID "
          ></v-autocomplete>
          <template
            slot="selection"
            slot-scope="item"
          >
            ID:{{ item.item.ID}} {{ item.item.Title}}
          </template>

          <template slot="item"
                    slot-scope="props">
            ID:{{ props.item.ID}} {{ props.item.Title}}
          </template>
          <v-alert dismissible
                   :value="addRelationErr"
                   type="error"
          >
            {{addRelationErr}}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="addRelation=false"> Άκυρο</v-btn>
          <v-btn color="light-green" flat @click="makeRelation()"> Προσθήκη</v-btn>
          <v-checkbox label=" Αποστολή Μυνήματος " v-model="newRelationSendEmail"></v-checkbox>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showMessages" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline"> Ειδοποιήση </span>
          <v-spacer></v-spacer>

        </v-card-title>
        <v-card-text>
          <span v-if="messages.length <= 0"> Η διαδικασία είναι σε εξέλιξη. Ας περιμένουμε λίγο...</span>
          <v-alert v-for="message in messages"
                   :type="!message.success?'error':'success'"
                   :value="true"
          >
            {{message.reason}}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="showMessages=false"> Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>


</template>

<script>
  import DatePicker from "@/components/DatePicker"
  import StoreState from "@/assets/StoreState";
  import ApiData from "@/assets/ApiData";
  import Emails from "@/components/Emails";
  import AddEmail from "@/components/AddEmail";

  export default {
    name: "Relations",
    data: () => ({
      admin: ApiData.admin,
      b2b: StoreState.b2b,
      addRelation: false,
      selectedCustomer: null,
      selectedCustomersEmails: null,
      selectedOffer:null,
      newOffer: null,
      newCustomer: null,
      openEmailModal: false,
      newRelationSendEmail: false,
      addRelationErr: "",
      rowsPerPageItems: [10, 15, 25],
      showMessages: false,
      pagination: {
        rowsPerPage: 10
      },
      messages: [],
    }),
    components: {
      DatePicker,
      Emails,
      AddEmail
    },
    methods: {

      onAddEmail(email){
        this.selectedCustomersEmails.push(email)
      },
      openEmail(customerID, offerID) {
        let customer = this.b2b.customerDictionary[customerID];
        let offer = this.b2b.offerDictionary[offerID];
        this.selectedCustomer = customer;
        this.selectedOffer = offer;

        ApiData.getExtraEmails(customerID)
          .then(resp => {
            this.selectedCustomersEmails = resp.data.data;
            this.$modal.show('emails');
          })
      },
      closeModal() {
        this.$modal.hide('emails');
        this.selectedCustomer = null;
        this.openEmailModal = false;
      },
      toggleRelation(item) {
        let offerID = item.OfferID;
        let customerID = item.CustomerID;
        StoreState.messages.isLoading = true;
        ApiData.toggleRelation(offerID, customerID)
          .then(resp => {
            if (resp) {
              StoreState.messages.isLoading = false;
              if (item.IsActive === '0') {
                item.IsActive = '1'
              } else {
                item.IsActive = '0'
              }
            } else {
              StoreState.messages.isLoading = false;
              this.$notify({
                group: 'messages',
                type: 'error',
                text: 'Υπήρξε κάποιο πρόβλημα στην αποθήκευση.'
              });
            }
            this.$notify({
              group: 'messages',
              type: resp ? 'success' : 'error',
              text: resp ? 'Αποθηκεύτηκε' : 'Υπήρξε κάποιο πρόβλημα στην αποθήκευση.'
            });

          }).catch(err => {
          StoreState.messages.isLoading = false;
          StoreState.messages.error = err;
          this.$notify({
            group: 'messages',
            type: 'error',
            text: 'Υπήρξε κάποιο πρόβλημα στην αποθήκευση.'
          });
        })
      },

      updateOfferField(id, field, value) {
        StoreState.messages.isLoading = true;
        ApiData.updateOfferField(id, field, value).then(
          resp => {
            if (resp) {
              console.log(resp);
              StoreState.updateOfferField(id, field, value);
            }
            StoreState.messages.isLoading = false;
            this.$notify({
              group: 'messages',
              type: 'success',
              text: 'Αποθηκεύτηκε'
            });
          }
        ).catch(err => {
          this.$notify({
            group: "messages",
            type: 'error',
            text: 'Υπήρξε κάποιο πρόβλημα στην αποθήκευση.'
          });
          StoreState.messages.isLoading = false;
          StoreState.messages.error = err;
        })
      },
      expiredColor(offer) {
        return StoreState.isOfferExpired(offer) ? "grey lighten-1" : "white"
      },
      expired(offer) {
        return StoreState.isOfferExpired(offer)

      },
      deleteRelation(customerID, offerID) {
        if (!window.confirm("Η ενέργεια την πρόσβαση, είστε σίγουροι;")) return;

        StoreState.messages.isLoading = true;
        ApiData.deleteRelation(offerID, customerID).then(
          resp => {
            if (resp) {
              StoreState.deleteRelation(customerID, offerID);
            }
            StoreState.messages.isLoading = false;
            this.$notify({
              group: 'messages',
              type: resp ? 'success' : 'error',
              text: resp ? 'Αποθηκεύτηκε' : 'Υπήρξε κάποιο πρόβλημα στην αποθήκευση.'
            });
          }
        ).catch(err => {
          StoreState.messages.isLoading = false;
          this.$notify({
            group: 'messages',
            type: 'error',
            text: 'Υπήρξε κάποιο πρόβλημα στην αποθήκευση.'
          });
        });
      },
      previewRelation(token, isCopy) {
        if (!isCopy) {
          window.open("https://b2b.pharm.gr/?t=" + token+'&admin=true');
        } else {
          this.copyStringToClipboard("https://b2b.pharm.gr/?t=" + token)
          this.$notify({
            group: 'messages',
            type: 'success',
            text: 'Αντιγράφθηκε στο πρόχειρο σας (πατήστε επικόληση κάπου για να τον δείτε)',
          });
        }
        // window.open("http://localhost:3000/?t=" + token);
      },
      copyStringToClipboard(str) {
        // Create new element
        var el = document.createElement('textarea');
        // Set value (string to be copied)
        el.value = str;
        // Set non-editable to avoid focus and move outside of view
        el.setAttribute('readonly', '');
        el.style = {position: 'absolute', left: '-9999px'};
        document.body.appendChild(el);
        // Select text inside element
        el.select();
        // Copy text to clipboard
        document.execCommand('copy');
        // Remove temporary element
        document.body.removeChild(el);
      },
      sendEmail(customerID, offerID,emails) {
        if (!window.confirm("Είστε σίγουροι ότι θέλετε να στείλετε μύνημα για την παραγγελία?;")) return;
        this.messages = [];
        this.showMessages = true;
        StoreState.messages.isLoading = true;
        ApiData.sendEmails(offerID, customerID,emails).then(
          resp => {
            this.messages = resp.data.data;
            StoreState.messages.isLoading = false;
            this.showMessages = true;

          }).catch(err => {
          StoreState.messages.isLoading = false;
          this.showMessages = true;
        });
      },
      resetRelations() {
        StoreState.resetRelations();
      },



      makeRelation() {
        if (StoreState.hasRelation(this.newOffer, this.newCustomer)) {
          this.addRelationErr = " Η σχέση αυτή υπάρχει ήδη ";
          this.newOffer = null;
          this.newCustomer = null;
          return
        }
        StoreState.messages.isLoading = true;
        this.addRelation = false;
        ApiData.makeRelation(this.newOffer, this.newCustomer)
          .then(resp => {
            if (resp.value) {
              StoreState.messages.isLoading = false;
              StoreState.makeRelation(this.newOffer, this.newCustomer, resp.token);
              StoreState.messages.success = "Η σχέση δημιουργήθηκε";
              if (this.newRelationSendEmail) {
                this.sendEmail(this.newCustomer, this.newOffer, [StoreState.b2b.customerDictionary[this.newCustomer].Email]);
              }
              this.newCustomer = null;
              this.newOffer = null;
              this.newRelationSendEmail = false;
            }

            this.$notify({
              group: 'messages',
              type: resp ? 'success' : 'error',
              text: resp ? 'Αποθηκεύτηκε' : 'Υπήρξε κάποιο πρόβλημα στην αποθήκευση.'
            });

          }).catch(err => {
          StoreState.messages.isLoading = false;
          StoreState.messages.error = err;
          this.newCustomer = null;
          this.newOffer = null;
          this.$notify({
            group: 'messages',
            type: 'error',
            text: 'Υπήρξε κάποιο πρόβλημα στην αποθήκευση.'
          });
        })
      }
    }

  }
</script>

<style scoped>

  .scroll-y {
    overflow: auto;
  }

  .boxes-front {
    max-height: 50vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/Relations.vue